import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Container from '@material-ui/core/Container';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';
import { PaymentPlanForm } from '../PaymentPlanForm/PaymentPlanForm';
import { PaymentPlanPriceRange } from "../PaymentPlanForm/PaymentPlanPriceRange/PaymentPlanPriceRange";
import { ActiveAgencyForm } from '../ActiveAgencyForm/ActiveAgencyForm';
import { ConfirmationButton } from "../ConfirmationButton/ConfirmationButton";
import { updateApplicationSettings, loadApplicationSettings, setActiveAgency } from '../../api/settings';
import cn from './AgencyConfigForm.module.scss';

export class AgencyConfigForm extends React.PureComponent {
  state = {
    expanded: false,
    allowAll: false,
    restrictionLevel: '',
    minPrice: '',
    maxPrice: '',
    paymentPlans: [],
    serviceAgencies: [],
    insuranceAgencies: [],
  };

  componentDidMount() {
    loadApplicationSettings().then(settings => {
      this.setState({
        allowAll: settings.restrictionLevel === null,
        restrictionLevel: settings.restrictionLevel,
        minPrice: settings.minPrice,
        maxPrice: settings.maxPrice,
        paymentPlans: settings.paymentPlans,
        serviceAgencies: settings.serviceAgencies,
        insuranceAgencies: settings.insuranceAgencies,
      })
    });
  }

  handlePanelChange = panel => (event, isExpanded) => {
    this.setState({expanded: isExpanded ? panel : false });
  };

  handleRestrictionLevelChange = (event) => {
    this.setState({
      restrictionLevel: parseInt(event.target.value, 10) || '',
    });
  };

  handleAllowAllChange = (event) => {
    this.setState({
      allowAll: event.target.checked,
    });
  };

  handlePriceRangeChange = ({ minPrice, maxPrice }) => {
    this.setState({
      minPrice,
      maxPrice,
    });
  };

  handleAdminRightsSubmit = async () => {
    const { allowAll, restrictionLevel } = this.state;
    try {
      await updateApplicationSettings({
        allowAll,
        restrictionLevel,
      });
    } catch (err) {
      console.error(err);
    }
  };

  handlePaymentPlansSubmit = async (paymentPlans) => {
    try {
      const { minPrice, maxPrice } = this.state;
      await updateApplicationSettings({
        minPrice,
        maxPrice,
        paymentPlans,
      });
    } catch (err) {
      console.error(err);
    }
  };

  handleSetActiveAgency = async ({ selectedAgencyId, type }) => {
    if (selectedAgencyId) {
      try {
        await setActiveAgency({
          id: selectedAgencyId,
          type
        });
      } catch (err) {
        console.error(err);
      }
    }
  };

  render() {
    const { expanded, allowAll, restrictionLevel, minPrice, maxPrice, paymentPlans } = this.state;

    return (
      <Container fixed className={cn.form}>
        <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handlePanelChange('panel1')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{ content: cn.panelSummaryContent }}>
            Grant Admin Rights
          </ExpansionPanelSummary>
          <ExpansionPanelDetails classes={{ root: cn.panelDetails }}>
            <div className={cn.label}>How many levels under super admin should have admin abilities for their network?</div>
            <FormGroup row classes={{root: cn.formGroup }}>
              <FormControlLabel
                control={
                  <Checkbox color="primary" checked={allowAll} onChange={this.handleAllowAllChange} />
                }
                label="Allow all agencies"
              />
              <TextField
                label="Restriction level"
                value={restrictionLevel}
                onChange={this.handleRestrictionLevelChange}
                classes={{ root: cn.textField }}
                disabled={allowAll}
                margin="dense"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormGroup>
            <FormGroup row classes={{root: cn.saveButton }}>
              <ConfirmationButton
                disabled={!allowAll && !restrictionLevel}
                onClick={this.handleAdminRightsSubmit}
              />
            </FormGroup>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handlePanelChange('panel2')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{ content: cn.panelSummaryContent }}>
            Application Pricing
          </ExpansionPanelSummary>
          <ExpansionPanelDetails classes={{ root: cn.panelDetails }}>
            <PaymentPlanPriceRange initialMinPrice={minPrice} initialMaxPrice={maxPrice} onChange={this.handlePriceRangeChange} />
            <PaymentPlanForm
              minPrice={minPrice}
              maxPrice={maxPrice}
              initialPlans={paymentPlans}
              onSubmit={this.handlePaymentPlansSubmit}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handlePanelChange('panel3')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{ content: cn.panelSummaryContent }}>
            Service agencies
          </ExpansionPanelSummary>
          <ExpansionPanelDetails classes={{ root: cn.panelDetails }}>
            <ActiveAgencyForm
              type={'service'}
              agencies={this.state.serviceAgencies}
              onSubmit={this.handleSetActiveAgency}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handlePanelChange('panel4')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{ content: cn.panelSummaryContent }}>
            Insurance agencies
          </ExpansionPanelSummary>
          <ExpansionPanelDetails classes={{ root: cn.panelDetails }}>
            <ActiveAgencyForm
              type={'insurance'}
              agencies={this.state.insuranceAgencies}
              onSubmit={this.handleSetActiveAgency}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Container>
    );
  }
}
